import { render, staticRenderFns } from "./CalendarSyncStatusButton.vue?vue&type=template&id=54528668&scoped=true&"
import script from "./CalendarSyncStatusButton.vue?vue&type=script&lang=js&"
export * from "./CalendarSyncStatusButton.vue?vue&type=script&lang=js&"
import style0 from "./CalendarSyncStatusButton.vue?vue&type=style&index=0&id=54528668&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54528668",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBadge,VBtn,VIcon,VTooltip})
